import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonAddIcon from "@mui/icons-material/PersonAddOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFileOutlined";
import { Button } from "@avenue-8/sidekick-ui";
import {
  ActionSheetMenu,
  ActionSheetMenuItemWithDescription,
  ResponsiveActionSheetMenu,
} from "@shared/components/ActionSheetMenu";

type AddContactMenuProps = {
  onAddManually: () => void;
  onImportFromCsv: () => void;
  // "compact" (default) is the tight navbar trigger. "regular" is a medium
  // outlined button, for places sitting alongside other regular-sized
  // buttons (e.g. next to the "Connect Google" button).
  variant?: "compact" | "regular";
};

export const AddContactMenu = ({
  onAddManually,
  onImportFromCsv,
  variant = "compact",
}: AddContactMenuProps) => {
  return (
    <ResponsiveActionSheetMenu
      renderTrigger={({ triggerRef, onClick }) => (
        <Button
          ref={triggerRef}
          variant="outlined"
          size={variant === "compact" ? "small" : "medium"}
          onClick={onClick}
          endIcon={<ExpandMoreIcon />}
        >
          Add contact
        </Button>
      )}
    >
      {(closeMenu) => (
        <ActionSheetMenu>
          <ActionSheetMenuItemWithDescription
            icon={<PersonAddIcon />}
            title="Add manually"
            description="Enter one contact's details"
            onClick={() => {
              closeMenu();
              onAddManually();
            }}
          />
          <ActionSheetMenuItemWithDescription
            icon={<UploadFileIcon />}
            title="Import from CSV"
            description="Bring in a list of contacts at once"
            onClick={() => {
              closeMenu();
              onImportFromCsv();
            }}
          />
        </ActionSheetMenu>
      )}
    </ResponsiveActionSheetMenu>
  );
};
